import React from 'react';
import ScrollReveal from './ScrollReveal';

const SectionHeading = ({ 
  title, 
  subtitle, 
  description = '',
  centered = true,
  light = false
}) => {
  return (
    <div className={`mb-10 md:mb-16 ${centered ? 'text-center mx-auto max-w-3xl' : ''}`}>
      <ScrollReveal>
        <div className="inline-block">
          <p className={`text-sm md:text-base tracking-widest uppercase mb-3 ${light ? 'text-primary-300' : 'text-accent-gold'}`}>
            {subtitle}
          </p>
        </div>
      </ScrollReveal>
      
      <ScrollReveal delay={0.1}>
        <h2 className="mb-4">
          {title}
        </h2>
      </ScrollReveal>
      
      {description && (
        <ScrollReveal delay={0.2}>
          <p className={`text-gray-300 text-lg md:text-2xl ${centered ? 'max-w-3xl mx-auto' : 'text-left'}`}>
            {description}
          </p>
        </ScrollReveal>
      )}
    </div>
  );
};

export default SectionHeading;